module.exports = __webpack_public_path__ + "img/community_detail_preview.5f32c1e.png";